// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 这里面文件导入顺序决定样式的覆盖
import Vue from "vue";
import router from "./router";
import store from "./store";
import vuescroll from 'vuescroll';
import storage from 'good-storage'
// 你可以在这里设置全局配置
Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: 'native',
      sizeStrategy: 'number',
      locking: true
    },
    bar: {
      background: "#00F68C"
    }
  }, // 在这里设置全局默认配置
  name: 'vueScroll' // 在这里自定义组件名字，默认是vueScroll
});

import { i18n } from "@/locales";
import 'default-passive-events'

import ElementUI from "element-ui";
Vue.use(ElementUI);

import "element-ui/lib/theme-chalk/index.css";
import "./assets/fonts/iconfont.css";

import animated from "animate.css";
Vue.use(animated);

import App from "./App";
import { getNavPoolCoins } from "@/http/account";

import ECharts from "vue-echarts/components/ECharts";
Vue.component("chart", ECharts);

//分页
import paging from "./components/paging";
Vue.component("paging", paging);


import mixins from "./mixins";
Vue.mixin(mixins);

// 引入mqtt
import "./mq";

/*科学计数法转换数值*/
Vue.prototype.$toNonExponential = function (num) {
  if (!num) return 0
  var m = Number(num)
    .toExponential()
    .match(/\d(?:\.(\d*))?e([+-]\d+)/);
  return Number(num).toFixed(Math.max(0, (m[1] || "").length - m[2]));
};

Vue.filter("toNonExponential", function (num) {
  if (!num) return 0
  var m = Number(num)
    .toExponential()
    .match(/\d(?:\.(\d*))?e([+-]\d+)/);
  return Number(num).toFixed(Math.max(0, (m[1] || "").length - m[2]));
});

Vue.config.productionTip = false;



// 获取筛选币种
getNavPoolCoins({}).then(res => {
  if (res && res.status == 200) {
    store.dispatch("setCurrencyData", res.data);
    let searchList = storage.get("_search_", []);
    if (!searchList.length > 0) return
    for (let i = 0; i < searchList.length; i++) {
      const element = searchList[i];
      const isExist = res.data.findIndex(event => event.coinCode == element.currency)
      if (isExist == -1) {
        searchList[i] = undefined
      }
    }

    searchList = searchList.filter((l) => l != undefined);
    storage.set("_search_", searchList);
  }
}).catch(err => {
  console.log(err)
}).finally(() => {
  // 初始化vue
  /* eslint-disable no-new */
  new Vue({
    el: "#app",
    router,
    i18n,
    store,
    components: { App },
    template: "<App/>",
  });
})






// WEBPACK FOOTER //
// ./src/main.js